import { YesNoAnswer } from "~/services/validation/YesNoAnswer";

export const fluggastrechteStreitKostenInputSchema = {
  prozesszinsen: YesNoAnswer,
};
